<template>
  <question-group headline="Top 10">
    <div v-if="!blast.blastPrompt.question.top || !blast.blastPrompt.question.top.length">
      <p>Check back soon and maybe you'll be in this list.</p>
      <p>You must rate at least <strong>five</strong> peers and receive at least <strong>five</strong> ratings to make the Top 10.</p>
    </div>
    <blast-top-10 :blast="blast" v-else />
  </question-group>
</template>

<script>

  import sidebar from "./sidebar.js"

  export default {
    name: 'top10',
    mixins: [sidebar]
  }
</script>



// WEBPACK FOOTER //
// src/components/BlastStudent/sidebar/top10.vue